import CreatorRoutes from '@/pages/Creator/routes';

import { getMatchFromPath } from './getMatchFromPath';
import { BasetenPageEnum, BasetenPageProps } from './types';

const Routes: Array<BasetenPageProps> = CreatorRoutes;

export function findMatchingPageFromPath(path: string): BasetenPageEnum | null {
  return getMatchFromPath(path)?.page;
}

export * from './hooks';
export * from './pageSwitcher';
export * from './renderRoutes';
export * from './types';
export * from './utils';
export { Routes, getMatchFromPath };
